import { Location } from '@angular/common';
import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { catchError, map, of } from 'rxjs';
import { AuthService, CurrentUserService } from '../services';

export const authGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const currentUserService = inject(CurrentUserService);
  const router = inject(Router);
  const location = inject(Location);

  if (!authService.isAuthenticated) {
    authService.setRedirectUrl(location.path());
    return router.parseUrl('/auth');
  }

  if (currentUserService.user()) {
    return true;
  }

  return authService.getCurrentUser().pipe(
    map(user => {
      currentUserService.user.set(user);
      return true;
    }),
    catchError(() => {
      authService.onLogout();
      return of(router.parseUrl('/auth'));
    }),
  );
};
